import { useLiveQuery } from 'dexie-react-hooks';
import { useSyncExternalStore } from 'react';
import { dbKey, hasDb, onDbChange, db } from '@/db';
import type { ShopDB } from '@/db/schema';

/** Re-render when the active shop database is swapped. */
export const useDbKey = (): string => useSyncExternalStore(onDbChange, dbKey);

/**
 * Live query over the shop database. `undefined` while loading, otherwise the result — screens use that to show their skeleton.
 * Re-runs whenever any table it read changes, which is how every list stays current after a write, a pull or an overlay recompute.
 */
export function useLive<T>(fn: (d: ShopDB) => Promise<T> | T, deps: unknown[] = []): T | undefined {
  const key = useDbKey();
  return useLiveQuery(async () => (hasDb() ? fn(db()) : undefined), [key, ...deps]);
}
